<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb" />
    <div class="wrap max-width">
      <div class="form-box">
        <div v-if="info.status === 4" class="no-pass">不通过原因：{{ info.logList[0].auditRmks }}</div>
        <div class="title">{{ info.prodtName }}</div>
        <div class="title-sub">
          <div class="company-name">{{ info.crtUserNm }}</div>
          <!-- <div>加入收藏</div> -->
        </div>
        <div class="product-info">
          <el-descriptions :column="2">
            <el-descriptions-item label="产品网址">{{ info.prodtUrl || '--' }}</el-descriptions-item>
            <el-descriptions-item label="企业经营地">{{ info.companyLocal || '--' }}</el-descriptions-item>
            <el-descriptions-item label="电子邮箱">{{ info.email || '--' }}</el-descriptions-item>
            <el-descriptions-item label="联系电话/手机">{{ info.contractNum || '--' }}/{{ info.contractPhone || '--' }} </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="product-box">
          <el-carousel height="20.83333vw" class="carousel">
            <el-carousel-item v-for="item in pictureList" :key="item">
              <img :src="item" alt="" width="100%" />
            </el-carousel-item>
          </el-carousel>
          <div class="product-content">{{ info.prodtDes }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data() {
    return {
      info: {},
      breadcrumb: [
        {
          path: '/user',
          name: '个人中心',
          meta: {
            title: '个人中心',
          },
        },
        {
          path: '/user/myProduct',
          name: '我的产品',
          meta: {
            title: '我的产品',
          },
        },
        {
          path: '/user/product/detail',
          name: '产品详情',
          meta: {
            title: '产品详情',
          },
        },
      ],
    }
  },
  computed: {
    pictureList() {
      if (this.info.prodtPictureUrl) {
        return this.info.prodtPictureUrl.split(',')
      }
      return []
    },
  },
  mounted() {
    this.queryDetail(this.$route.query.id)
  },
  methods: {
    queryDetail(id) {
      this.$http({ method: 'get', url: '/zzmh/in/product/info/' + id }).then((res) => {
        this.info = res.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .no-pass {
    position: absolute;
    left: 20px;
    top: 20px;
    color: red;
    width: 400px;
  }
  .wrap {
    display: flex;
    flex-direction: column;
    .product-info {
      background: #f6f7fb;
      border-radius: 4px;
      padding: 20px;
      padding-top: 30px;
      /deep/ .el-descriptions__body {
        background: transparent;
      }
    }
    .form-box {
      position: relative;
      flex: 1;
      background: #fff;
      padding: 30px;
      .title-sub {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #8c8c8c;
        text-align: center;
        font-weight: 400;
        display: flex;
        justify-content: center;
        margin-bottom: 15px;
      }
      .company-name {
        margin-right: 30px;
      }
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 24px;
        color: rgba(51, 51, 51, 0.85);
        text-align: center;
        line-height: 24px;
        font-weight: 600;
        margin-bottom: 15px;
      }
    }
    .product-box {
      display: flex;
      margin-top: 20px;
      .carousel {
        width: 533px;
      }
      .product-content {
        flex: 1;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333333;
        letter-spacing: 0;
        text-align: justify;
        font-weight: 500;
        margin-left: 20px;
      }
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
